// ABOUTME: simple dark mode toggle button for navigation areas
// ABOUTME: provides quick switching between light and dark modes with system fallback

import { IconButton, Tooltip } from "@mui/material";
import { Moon, Sun } from "lucide-react";
import React from "react";
import { useAppTheme } from "../hooks/useAppTheme";

interface DarkModeToggleProps {
  size?: "small" | "medium" | "large";
}

const DarkModeToggle: React.FC<DarkModeToggleProps> = ({ size = "medium" }) => {
  const { mode, setMode } = useAppTheme();

  const handleToggle = () => {
    if (mode === "light") {
      setMode("dark");
    } else {
      setMode("light");
    }
  };

  const getIcon = () => {
    switch (mode) {
      case "light":
        return (
          <Sun size={size === "small" ? 16 : size === "large" ? 24 : 20} />
        );
      case "dark":
        return (
          <Moon size={size === "small" ? 16 : size === "large" ? 24 : 20} />
        );
      default:
        return (
          <Sun size={size === "small" ? 16 : size === "large" ? 24 : 20} />
        );
    }
  };

  const getTooltip = () => {
    switch (mode) {
      case "light":
        return "Switch to dark mode";
      case "dark":
        return "Switch to light mode";
      default:
        return "Toggle theme";
    }
  };

  return (
    <Tooltip title={getTooltip()}>
      <IconButton onClick={handleToggle} size={size} color="inherit">
        {getIcon()}
      </IconButton>
    </Tooltip>
  );
};

export default DarkModeToggle;
